export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-02.f7697a78.png";